import React from 'react';
import {pitchLimits, restCheck, total} from "../../simulationFunctions";
import {borderBottomStyle, borderSideStyle} from "./tableStyles";
import {SimulationData} from "../../simulationTypes";
import {modifySimGame1, modifySimGame2} from "./tableFunctions";
import {RuleType} from "../../RuleType";

type Props = {
  simulation: SimulationData;
  simulations: SimulationData[];
  setSimulations: React.Dispatch<React.SetStateAction<SimulationData[]>>;
  rule: RuleType
}

export const FirstGame: React.VFC<Props> = (props) => {
  const limit = pitchLimits(props.rule)
  return (
    <>
      <td className={borderBottomStyle + (props.simulation.today.pitch_2 < limit.oneDay ? '':'bg-gray-400')}>
        {props.simulation.today.pitch_2 < limit.oneDay ? (
          <input
            type="number"
            min="0"
            className='pl-2 w-14 text-2xl font-bold bg-transparent text-center'
            value={props.simulation.today.pitch_1 ? props.simulation.today.pitch_1: ''}
            //内部処理はmodifySimGame1に
            onChange={
              (e) => {
                props.setSimulations([...modifySimGame1(props.simulation, props.simulations, e.target.value, props.rule)])
              }
            }
          />
        ):(
          ''
        )}
      </td>
      <td className={borderBottomStyle + borderSideStyle + (props.simulation.today.pitch_1 < limit.oneDay ? '':'bg-gray-500')}>
        {props.simulation.today.pitch_1 < limit.oneDay ? (
          <input
            type="number"
            min="0"
            className='pl-2 w-14 text-2xl font-bold bg-transparent text-center'
            value={props.simulation.today.pitch_2 ? props.simulation.today.pitch_2: ''}
            //内部処理はmodifySimGame2に
            onChange={
              (e) => {
                props.setSimulations([...modifySimGame2(props.simulation, props.simulations, e.target.value, props.rule)])
              }
            }
          />
        ):(
          ''
        )}
      </td>
      <td className={'text-2xl font-bold text-center ' + borderBottomStyle + borderSideStyle}>
        {total(props.simulation.today)}
      </td>
      <td className={'text-2xl font-bold text-center ' + borderBottomStyle + borderSideStyle + (restCheck(props.simulation.today) <= 0 ? 'text-white bg-gray-500 border-r-white' : '')}>
        {restCheck(props.simulation.today) <=0 ? 'NO' : restCheck(props.simulation.today)}
      </td>
      <td
        className={'text-2xl font-bold text-center bg-blue-200 ' + borderBottomStyle + borderSideStyle}>
        {props.simulation.today.limit}
      </td>
    </>
  );
};
